import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'public-footer',
    imports: [
      RouterLink
    ],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponent {
  year = new Date().getFullYear();
}
